import { _GettersTree } from 'pinia';
import { getRelevantReviewFromList } from '../../helpers';
import { ICarReviewStoreState } from '../../interfaces/ICarReviewStoreState';
import { IExpertReview, IExpertReviewPayload } from '../../interfaces/IExpertReview';
import { IReviewDocument } from '../../interfaces/IReviewSearchResult';
/**
 * Getters for Car review store
 */
interface ICarReviewStoreGetters {
  getRelevantReview: (state: ICarReviewStoreState) => (make: string, model: string, trim: string) => IReviewDocument;
  getReviewById: (state: ICarReviewStoreState) => (reviewId: string) => IExpertReview;
}
export const carReviewGetters: ICarReviewStoreGetters = {
  /**
   * If more than one review exists in the above API response, then the review should be selected as per below business rules.
   *
   *    If more than one review exists for a vehicle make and model and trim:
   *  - When there is more than one review from RACQ and any other clubs, RACQ’s review is the one that should be used.
   *  - When more than one RACQ review is available, the most recent one should be used.
   *  - When no review from RACQ exists, but yes for other clubs, surface the most recent one.
   */
  getRelevantReview: (state: ICarReviewStoreState) => {
    return (make: string, model: string, trim: string) => {
      if (make && model) {
        const reviews = state.reviews?.filter((x) => x.make == make.toLowerCase() && x.model == model.toLowerCase())[0]?.reviews;
        return getRelevantReviewFromList(reviews, trim);
      }
      return {} as IReviewDocument;
    };
  },
  /**
   * Get review by review id from store
   * @param state
   * @returns
   */
  getReviewById: (state: ICarReviewStoreState) => {
    return (reviewId: string) => {
      let matchReview: IExpertReview = {} as IExpertReview;
      state.storedReviews.forEach((review) => {
        if (review)
          review.reviews.forEach((currReview) => {
            if (currReview.id == reviewId) matchReview = currReview.VehicleReview;
          });
      });
      return matchReview;
    };
  },
};
